import { useEffect, useState, type ReactNode } from 'react';

const TYPING_DOTS_MS = 700;

interface BotBubbleProps {
  children: ReactNode;
  showTypingDots: boolean;
}

export function BotBubble({ children, showTypingDots }: BotBubbleProps) {
  const [phase, setPhase] = useState<'dots' | 'text'>(
    showTypingDots ? 'dots' : 'text'
  );

  useEffect(() => {
    if (!showTypingDots) {
      setPhase('text');
      return;
    }
    const timeoutId = window.setTimeout(() => setPhase('text'), TYPING_DOTS_MS);
    return () => window.clearTimeout(timeoutId);
  }, [showTypingDots]);

  if (phase === 'dots') {
    return (
      <div className="bg-slate-50 border border-slate-100 rounded-2xl px-4 py-3 self-start inline-flex items-center gap-1.5 deep-dive-slide-fade">
        <span className="deep-dive-typing-dot" />
        <span className="deep-dive-typing-dot" />
        <span className="deep-dive-typing-dot" />
      </div>
    );
  }

  return (
    <div className="bg-slate-50 border border-slate-100 rounded-2xl px-4 py-3 max-w-[85%] self-start text-[14.5px] text-slate-800 leading-snug deep-dive-slide-fade whitespace-pre-wrap break-words">
      {children}
    </div>
  );
}
